import React from "react";
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";
import CancelRefundRequest from "../components/CancelRefundRequest";

const CancelRefundRequestPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <Header />
      <main className="flex-1">
        <CancelRefundRequest />
      </main>
      <Footer />
    </div>
  );
};

export default CancelRefundRequestPage;
